/** SegmentScrollCo 浮动吸顶与 NewFilter 吸顶联动（同 syncId 配对） */
export const SEGMENT_FLOAT_STICKY_SYNC_EVENT =
  'dbd-segment-scroll-co-float-sticky-sync';

export interface ISegmentFloatStickySyncDetail {
  syncId: string;
  stuck: boolean;
}
